import _map from 'lodash/map';
import _includes from 'lodash/includes';
import _find from 'lodash/find';
import _split from 'lodash/split';
import _head from 'lodash/head';
import _concat from 'lodash/concat';
import _reduce from 'lodash/reduce';
import APPCONFIG from '../../constants/Config';
import { WS_TOPIC_DEVICES, WS_TOPIC_CONFIG, WS_TOPIC_SLAVES } from '../../constants/App';
import * as wsEvents from '../../constants/WsEvents';
import {
  GET_DEVICES_LIST,
  GET_DEVICES_LIST_SUCCESS,
  GET_DEVICE,
  GET_DEVICE_SUCCESS,
  GET_DEVICE_INFO,
  GET_DEVICE_INFO_SUCCESS,
  GET_DEVICE_SYNC,
  GET_DEVICE_SYNC_SUCCESS,
  GET_INSTALLATION,
  GET_INSTALLATIONS_LIST,
  GET_INSTALLATIONS_LIST_SUCCESS,
  GET_INSTALLATION_DEVICES,
  GET_INSTALLATION_DEVICES_SUCCESS,
  GET_INSTALLATION_DEVICE,
  GET_INSTALLATION_DEVICE_SUCCESS,
  GET_SIMCARDS_LIST,
  GET_SIMCARDS_LIST_SUCCESS,
  GET_SIMCARD,
  GET_ROLLOUT_DEVICES_LIST,
  GET_ROLLOUT_DEVICES_LIST_SUCCESS,
  GET_DEVICE_SLAVES_LIST,
  GET_DEVICE_SLAVES_LIST_SUCCESS,
  GET_DEVICE_SLAVE,
  WS_RECEIVED_OPERATION,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import {
  deserialize, deserializeSyncStatus, updateIsNeeded, updateFromServerData,
} from '../../models/device';
/* eslint-enable import/named */

const managedTopics = [WS_TOPIC_DEVICES, WS_TOPIC_CONFIG, WS_TOPIC_SLAVES];

const initialSettings = APPCONFIG.deviceData;
const deviceData = (state = initialSettings, action) => {
  let wsPayload;
  let wsTopic;
  let wsData;
  switch (action.type) {
    /**
    * Actions that empty the elements
    */
    case GET_DEVICES_LIST:
    case GET_DEVICE:
    case GET_INSTALLATION:
    case GET_INSTALLATIONS_LIST:
    case GET_INSTALLATION_DEVICES:
    case GET_SIMCARDS_LIST:
    case GET_SIMCARD:
    case GET_DEVICE_SLAVES_LIST:
    case GET_DEVICE_SLAVE:
      if (action.cbParams && action.cbParams.updateDeviceData) {
        return {
          ...state,
          desynchronized: false,
          elements: [],
          withAllInfoElements: [],
        };
      }
      return state;
    case GET_ROLLOUT_DEVICES_LIST:
      return {
        ...state,
        desynchronized: false,
        elements: [],
        withAllInfoElements: [],
      };
    /**
    * Actions from devices views
    */
    case GET_DEVICES_LIST_SUCCESS:
      if (action.updateDeviceData) {
        return {
          ...state,
          elements: deserialize(action.data.data),
        };
      }
      return state;
    case GET_DEVICE_SUCCESS:
      if (action.updateDeviceData) {
        return {
          ...state,
          elements: [deserialize(action.data.data)],
        };
      }
      return state;
    /**
    * Actions from installations views
    */
    case GET_INSTALLATIONS_LIST_SUCCESS:
      if (action.updateDeviceData) {
        return {
          ...state,
          elements: _reduce(action.data.data, (result, installation) => (_concat(result, deserialize(installation.devices))), []),
        };
      }
      return state;
    case GET_INSTALLATION_DEVICES_SUCCESS:
      if (action.updateDeviceData) {
        return {
          ...state,
          elements: deserialize(action.data.data),
        };
      }
      return state;
    case GET_INSTALLATION_DEVICE:
      return {
        ...state,
        withAllInfoElements: !_find(state.withAllInfoElements, ['id', action.idDevice])
          ? [...state.withAllInfoElements, { id: action.idDevice, loading: true }]
          : _map(state.withAllInfoElements, (device) => (device.id === action.idDevice
            ? {
              ...device,
              loading: true,
            } : device
          )),
      };
    case GET_DEVICE_INFO:
      return {
        ...state,
        withAllInfoElements: !_find(state.withAllInfoElements, ['id', action.id])
          ? [...state.withAllInfoElements, { id: action.id, loading: true }]
          : _map(state.withAllInfoElements, (device) => (device.id === action.id
            ? {
              ...device,
              loading: true,
            } : device
          )),
      };
    case GET_INSTALLATION_DEVICE_SUCCESS:
    case GET_DEVICE_INFO_SUCCESS:
      return {
        ...state,
        withAllInfoElements: _map(state.withAllInfoElements, (device) => (device.id === action.data.data.id
          ? {
            ...device,
            ...deserialize(action.data.data),
            loading: false,
          } : device
        )),
      };
    case GET_DEVICE_SYNC:
      return {
        ...state,
        withAllInfoElements: _map(state.withAllInfoElements, (device) => (device.id === action.id
          ? {
            ...device,
            syncLoading: true,
          } : device
        )),
        elements: _map(state.elements, (device) => (device.id === action.id
          ? {
            ...device,
            syncLoading: true,
          } : device
        )),
      };
    case GET_DEVICE_SYNC_SUCCESS:
      return {
        ...state,
        withAllInfoElements: _map(state.withAllInfoElements, (device) => (device.id === action.id
          ? {
            ...device,
            sync_status: {
              ...deserializeSyncStatus(action.data.data),
            },
            syncLoading: false,
          } : device
        )),
        elements: _map(state.elements, (device) => (device.id === action.id
          ? {
            ...device,
            sync_status: {
              ...deserializeSyncStatus(action.data.data),
            },
            syncLoading: false,
          } : device
        )),
      };
    /**
    * Actions from simcards views
    */
    case GET_SIMCARDS_LIST_SUCCESS:
      if (action.updateDeviceData) {
        return {
          ...state,
          elements: _reduce(action.data.data, (result, simcard) => {
            if (simcard.device) {
              result.push(deserialize(simcard.device));
            }
            return result;
          }, []),
        };
      }
      return state;
    /**
    * Actions from rollouts views
    */
    case GET_ROLLOUT_DEVICES_LIST_SUCCESS:
      return {
        ...state,
        elements: deserialize(_map(action.data.data, 'device')),
      };
    /**
    * Actions from device slaves views
    */
    case GET_DEVICE_SLAVES_LIST_SUCCESS:
      if (action.updateDeviceData) {
        return {
          ...state,
          elements: _reduce(action.data.data, (result, deviceSlave) => {
            if (deviceSlave.device) {
              result.push(deserialize(deviceSlave.device));
            }
            return result;
          }, []),
        };
      }
      return state;
    /**
    * Websocket operations catching
    */
    case WS_RECEIVED_OPERATION:
      wsPayload = action.payload;
      wsTopic = _head(_split(action.topic, ':'));

      if (wsPayload && wsTopic && _includes(managedTopics, wsTopic)) {
        wsData = wsPayload.data;
        switch (action.operation) {
          case wsEvents.EVENT_CREATE:
          case wsEvents.EVENT_UPDATE:
          case wsEvents.EVENT_DELETE:
            return {
              ...state,
              desynchronized: true,
            };
          case wsEvents.EVENT_INFO:
            if (wsTopic === WS_TOPIC_DEVICES && wsData) {
              if (updateIsNeeded(wsPayload.id, wsData)) {
                return {
                  ...state,
                  elements: _map(state.elements, (device) => (device.id === wsPayload.id
                    ? updateFromServerData(device, wsData) : device
                  )),
                  withAllInfoElements: _map(state.withAllInfoElements, (device) => (device.id === wsPayload.id
                    ? updateFromServerData(device, wsData) : device
                  )),
                };
              }
              return state;
            }
            return state;
          case wsEvents.EVENT_HEAD:
            if (wsTopic === WS_TOPIC_CONFIG) {
              return {
                ...state,
                elements: _map(state.elements, (device) => ((device.config && device.config.id === wsPayload.id)
                  ? {
                    ...device,
                    config: {
                      ...device.config,
                      sync_status: wsPayload.sync_status,
                    },
                  } : device
                )),
                withAllInfoElements: _map(state.withAllInfoElements, (device) => ((device.config && device.config.id === wsPayload.id)
                  ? {
                    ...device,
                    config: {
                      ...device.config,
                      sync_status: wsPayload.sync_status,
                    },
                  } : device
                )),
              };
            }
            if (wsTopic === WS_TOPIC_SLAVES) {
              return {
                ...state,
                elements: _map(state.elements, (device) => ((_find(device.device_slaves, ['id', wsPayload.id]))
                  ? {
                    ...device,
                    device_slaves: _map(device.device_slaves, (slave) => (slave.id === wsPayload.id
                      ? {
                        ...slave,
                        sync_status: wsPayload.sync_status,
                      } : slave
                    )),
                  } : device
                )),
                withAllInfoElements: _map(state.withAllInfoElements, (device) => ((_find(device.device_slaves, ['id', wsPayload.id]))
                  ? {
                    ...device,
                    device_slaves: _map(device.device_slaves, (slave) => (slave.id === wsPayload.id
                      ? {
                        ...slave,
                        sync_status: wsPayload.sync_status,
                      } : slave
                    )),
                  } : device
                )),
              };
            }
            return state;
          default:
            return state;
        }
      }
      return state;
    default:
      return state;
  }
};

export default deviceData;



// WEBPACK FOOTER //
// ./reducers/deviceData/deviceData.js